import React from 'react';
import { Route } from 'react-router-dom';
import Trophies from './trophies';

export default <Route path="/homepage/trofeus" component={Trophies} />;
